var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeneralActionShareAosBlack = function SvgGeneralActionShareAosBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    fillRule: "evenodd",
    d: "M15.737 17.537a2.76 2.76 0 0 1 1.725-.613 2.788 2.788 0 1 1-2.788 2.788c0-.34.07-.661.18-.962l-6.56-4.602a2.76 2.76 0 0 1-1.756.64 2.788 2.788 0 1 1 0-5.576c.667 0 1.27.243 1.75.634l6.557-4.628a2.8 2.8 0 0 1-.171-.93 2.788 2.788 0 1 1 2.788 2.788c-.667 0-1.27-.243-1.75-.634L9.154 11.07c.104.292.171.602.171.93 0 .325-.066.632-.168.921zM17.462 3c.71 0 1.288.578 1.288 1.288a1.29 1.29 0 0 1-1.288 1.288 1.29 1.29 0 0 1-1.288-1.288c0-.71.578-1.288 1.288-1.288M5.25 12c0 .71.578 1.288 1.288 1.288A1.29 1.29 0 0 0 7.826 12a1.29 1.29 0 0 0-1.288-1.288A1.29 1.29 0 0 0 5.25 12m10.924 7.712c0 .71.578 1.288 1.288 1.288a1.289 1.289 0 1 0-1.288-1.288",
    clipRule: "evenodd"
  })));
};
export default SvgGeneralActionShareAosBlack;